import { useQuery } from '@tanstack/react-query';
import { getPaymentMethodList } from '../../api/payment-method.ts';

export function usePaymentMethodList() {
  return useQuery({
    queryKey: ['paymentMethods'],
    queryFn: async () => {
      return await getPaymentMethodList();
    },
  });
}
